import { baseApi } from '@/api/rtk/baseApi';
import { runMutation } from '@/api/rtk/runEndpoint';
import { makeApiCall } from '@/api/makeApiCall';
import '@/api/rtk/mutationsApi';

const authBase = import.meta.env.VITE_AWS_AUTH_API_ENDPOINT;

function createUserErrorMessage(error) {
  const message =
    typeof error === 'string' ? error : error?.data || error?.message;
  switch (message) {
    case 'Invalid organisation Id':
      return 'Invalid invite Id';
    case 'User account already exists':
      return 'Email already registered. Please login.';
    default:
      return 'Failed to sign up. Please try again.';
  }
}

/** Creates org + admin for the authenticated Cognito user. Returns Cognito sub. */
export const createUser = async ({ name, orgName }) => {
  try {
    const data = await runMutation(baseApi.endpoints.createUser, {
      name,
      orgName,
    });
    if (!data?.userId) {
      throw new Error('Failed to sign up. Please try again.');
    }
    return data.userId;
  } catch (error) {
    if (error?.message === 'Failed to sign up. Please try again.') {
      throw error;
    }
    throw new Error(createUserErrorMessage(error));
  }
};

/**
 * Remove an UNCONFIRMED Cognito user so signup can retry with a new password.
 * Auth API host (VITE_AWS_AUTH_API_ENDPOINT) with gateway Authorizer NONE — not the public API
 * (public /cleanup-unconfirmed-signup currently 403s; auth host returns 200 + CORS).
 * @returns {true|false|null} true cleaned/ok, false already confirmed, null request failed
 */
export async function cleanupUnconfirmedSignup(email) {
  const result = await makeApiCall({
    endpoint: authBase,
    path: '/cleanup-unconfirmed-signup/',
    data: { email },
    requiresAuth: false,
    skipErrorToast: true,
  });

  if (result?.success) {
    return true;
  }

  const message =
    result?.error?.message || result?.data?.message || result?.data?.error || '';
  if (/already exists/i.test(String(message))) {
    return false;
  }
  return null;
}
